import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';

import { IOuter } from '../../EmptyState.types';
import styles from './SiteFilesNewDnDSubtitle.scss';

export const SiteFilesNewDnDSubtitle: FC<IOuter> = () => (
  <span className={styles.subtitle}>
    <FormattedMessage id="empty-state.folder-subtitle-new-dnd" />
  </span>
);
